'use strict';

var isString = require('lodash/lang/isString');
var extend = require('lodash/object/assign');
var luhn10 = require('./luhn-10');
var getCardTypes = require('credit-card-type');
var isNumber = require('lodash/lang/isNumber');

function verification(card, isPotentiallyValid, isValid) {
  return extend({}, {card: card, isPotentiallyValid: isPotentiallyValid, isValid: isValid});
}

function cardNumber(value) {
  var potentialTypes, cardType, isPotentiallyValid, isValid, i, maxLength;

  if (isNumber(value)) {
    value = String(value);
  }

  if (!isString(value)) { return verification(null, false, false); }

  value = value.replace(/\-|\s/g, '');

  if (!/^\d*$/.test(value)) { return verification(null, false, false); }

  potentialTypes = getCardTypes(value);

  if (potentialTypes.length === 0) {
    return verification(null, false, false);
  } else if (potentialTypes.length !== 1) {
    return verification(null, true, false);
  }

  cardType = potentialTypes[0];

  if (cardType.type === 'unionpay') {  // UnionPay is not Luhn 10 compliant
    isValid = true;
  } else {
    isValid = luhn10(value);
  }

  maxLength = Math.max.apply(null, cardType.lengths);

  for (i = 0; i < cardType.lengths.length; i++) {
    if (cardType.lengths[i] === value.length) {
      isPotentiallyValid = value.length !== maxLength || isValid;
      return verification(cardType, isPotentiallyValid, isValid);
    }
  }

  return verification(cardType, value.length < maxLength, false);
}

module.exports = cardNumber;



//////////////////
// WEBPACK FOOTER
// ./~/card-validator/src/card-number.js
// module id = 827
// module chunks = 47